import React from "react";
import Icon from "sulu-admin-bundle/components/Icon";
import AddCardEvent from "./CardEvent/AddCardEvent";
import EditCardEvent from "./CardEvent/EditCardEvent";

const ChangeEventType = ({
  EVENT_TYPES,
  eventDetails,
  setEventDetails,
  changeCallback,
  confirmCallback,
  preventChange
}) => {
  return (
    <div
      style={{
        padding: "10px 30px",
        display: "flex",
        // alignItems: "center",
      }}
    >
      <div
        style={{
          borderRadius: "50%",
          background: "transparent",
          border: "1px solid black",
          height: 35,
          width: 35,
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: 20,
        }}
      >
        <Icon name="fa-certificate" />
      </div>
      {eventDetails?.type && (
        <button
          style={{
            borderRadius: 2,
            background: eventDetails?.typeOfPsGoalSelected ? 'red' : eventDetails?.type?.background,
            color: "white",
            border: "none",
            height: 40,
            width: eventDetails?.type?.width || "15%",
            fontWeight: 700,
            marginRight: 30,
          }}
        >
            {eventDetails?.typeOfPsGoalSelected ?
                eventDetails?.typeOfPsGoalSelected?.name :
                eventDetails?.type?.name }
        </button>
      )}

      {eventDetails?.type && !preventChange ? (
        <button
          style={{
            border: "none",
            background: "transparent",
            fontSize: "16px",
          }}
          onClick={() => {
            setEventDetails((data) => ({
              ...data,
              type: null,
            }));
            changeCallback && changeCallback();
          }}
        >
          X
          <span
            style={{
              border: "none",
              background: "transparent",
              fontSize: "16px",
              textDecoration: "underline",
              marginLeft: 5,
            }}
          >
            Ändern
          </span>
        </button>
      ) : null}

      {!eventDetails?.type && (
        <div
          style={{
            width: "75%",
          }}
        >
          <div
            style={{
              display: "flex",
            }}
          >
            {EVENT_TYPES?.slice(0, 4)?.map((et, index) => {
              return (
                <button
                  key={index}
                  style={{
                    borderRadius: 2,
                    background: et?.background,
                    color: "white",
                    border: "none",
                    height: 40,
                    width: et?.width || "15%",
                    fontWeight: 700,
                    marginRight: 10,
                  }}
                  onClick={() => {
                    setEventDetails((data) => {
                      return {
                        ...data,
                        type:
                          et?.name === "GELB" &&
                          (data?.playerSelected?.cards || []).includes("GELB")
                            ? {
                                name: `GELB ROT`,
                                background:
                                  "linear-gradient(-45deg, #FF0014 50%, #F8D200 50%)",
                                addComponentToOpen: AddCardEvent,
                                editComponentToOpen: EditCardEvent,
                              }
                            : et,
                      };
                    });
                    confirmCallback && confirmCallback(et);
                  }}
                >
                  {et?.name}
                </button>
              );
            })}
          </div>
          <div
            style={{
              display: "flex",
              marginTop: 15,
            }}
          >
            {EVENT_TYPES?.slice(4)?.map((et, index) => {
              return (
                <button
                  key={index}
                  style={{
                    borderRadius: 2,
                    background: et?.background,
                    color: "white",
                    border: "none",
                    height: 40,
                    width: et?.width || "15%",
                    fontWeight: 700,
                    marginRight: 10,
                  }}
                  onClick={() => {
                    setEventDetails((data) => ({
                      ...data,
                      type: et,
                    }));
                    confirmCallback && confirmCallback(et);
                  }}
                >
                  {et?.name}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ChangeEventType;
